import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgCollapse({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.998 9.415l-5.293 5.29a1 1 0 11-1.414-1.414l6-5.997a.997.997 0 011.414 0l6 5.997a1 1 0 01-1.414 1.414l-5.293-5.29z"
        fill={color}
      />
    </svg>
  )
}

export default SvgCollapse
